import { getUserToken } from '@/helper/index'

export function getHttpHeaders () {
  /**
   * Возвращает заголовки запроса для отправки JSON данных
   * @returns {Object} объект с заголовками запроса
   */
  const headers = {
    'Content-Type': 'application/json'
  }
  if (getUserToken()) { headers.Authorization = 'Token ' + getUserToken() }
  return headers
}

export function getHttpHeadersFile () {
  /**
   * Возвращает заголовки запроса для отправки файлов
   * @returns {Object} объект с заголовками запроса
   */
  const headers = {}
  if (getUserToken()) { headers.Authorization = 'Token ' + getUserToken() }
  return headers
}

export function makeGetRequest (url, addheaders, signal = undefined) {
  /**
   * Выполняет GET-запрос для получения данных
   * @param {string} url - адрес, на который отправляется запрос
   * @param {Object} addheaders - дополнительные заголовки запроса
   * @param {AbortSignal} signal - параметр fetch для управления запросом
   * @returns {Promise} промис запроса
   */
  const headers = getHttpHeaders()
  return fetch(url, {
    headers,
    method: 'GET',
    signal
  })
}

export function makePostRequest (url, data, method, addheadres) {
  /**
   * Выполняет POST-запрос с отправкой данных в формате JSON
   * @param {string} url - адрес, на который отправляется запрос
   * @param {Object} data - данные для отправки
   * @param {string} method - HTTP-метод
   * @param {Object} addheaders - дополнительные заголовки запроса
   * @returns {Promise} промис запроса
   */
  const headers = getHttpHeaders()
  if (!method) { method = 'POST' }
  return fetch(url, {
    headers,
    method,
    body: JSON.stringify(data)
  })
}

export function makePostRequestFile (url, data, method, addheadres) {
  /**
   * Выполняет запрос с отправкой данных типа FormData
   * @param {string} url - адрес, на который отправляется запрос
   * @param {FormData} data - данные для отправки в формате FormData
   * @param {string} method - HTTP-метод
   * @param {Object} addheaders - дополнительные заголовки запроса
   * @returns {Promise} промис запроса
   */
  const headers = getHttpHeadersFile()
  if (!method) { method = 'POST' }
  return fetch(url, {
    headers,
    method,
    body: data
  })
}

export function makeUpdateRequest (url, data, addheaders) {
  /**
   * Выполняет PUT-запрос с отправкой данных в формате JSON
   * @param {string} url - адрес, на который отправляется запрос
   * @param {Object} data - данные для отправки
   * @param {Object} addheaders - дополнительные заголовки запроса
   * @returns {Promise} промис запроса
   */
  const headers = getHttpHeaders()
  return fetch(url, {
    headers,
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function makeParticalUpdateRequest (url, data, addheaders) {
  /**
   * Выполняет PATCH-запрос для частичного изменения объекта
   * @param {string} url - адрес, на который отправляется запрос
   * @param {Object} data - данные для отправки
   * @param {Object} addheaders - дополнительные заголовки запроса
   * @returns {Promise} промис запроса
   */
  return makePostRequest(url, data, 'PATCH')
}

export function makeDeleteRequest (url) {
  /**
   * Выполняет DELETE-запрос
   * @param {string} url - адрес, на который отправляется запрос
   * @returns {Promise} промис запроса
   */
  const headers = getHttpHeaders()
  return fetch(url, {
    headers,
    method: 'DELETE'
  })
}

export function finalizeRequest (request, finalizer = () => {}, catcher = () => {}, log = () => {}, result_data_type = 'json') {
  /**
   * Обрабатывает завершение запроса и вызывает соответствующие колбэки
   * @param {Promise} request - промис запроса
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   * @param {Function} log - функция логирования запросов (resp, data) => {}
   * @param {string} result_data_type - тип данных ответа
   */
  if (finalizer === undefined || finalizer === null) finalizer = () => {}
  if (catcher === undefined || catcher === null) catcher = () => {}
  if (log === undefined || log === null) log = () => {}
  return request
    .then(resp => {
      if (!resp.ok) {
        return resp.json()
          .then((json) => {
            log(resp, json)
            catcher(json)
          })
          .catch((err) => {
            log(resp, err)
            catcher(err)
          })
      } else {
        return resp[result_data_type]()
          .then(json => {
            log(resp, json)
            finalizer(json)
          })
          .catch((err) => {
            log(resp, err)
            finalizer(undefined)
          })
      }
    }).catch(error => {
      log(null, error)
      catcher(error)
    })
}

export function postFileRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет POST-запрос для отправки файлов с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {FormData} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makePostRequestFile(url, data, 'POST'), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function saveFileRequest (url, finalizer = () => {}, catcher = () => {}, signal = undefined) {
  /**
   * Выполняет GET-запрос для скачивания бинарных данных
   * @param {string} url - URL для запроса
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   * @param {AbortSignal} signal - параметр fetch для управления запросом
   */
  finalizeRequest(makeGetRequest(url, {}, signal), (data) => finalizer(data, url), (data) => catcher(data, url), () => {}, 'blob')
}

export function patchFileRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет PATCH-запрос для частичного обновления данных
   * @param {string} url - URL для запроса
   * @param {FormData} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makePostRequestFile(url, data, 'PATCH'), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function updateFileRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет PUT-запрос для полного обновления данных
   * @param {string} url - URL для запроса
   * @param {FormData} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makePostRequestFile(url, data, 'PUT'), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function sendGetRequest (url, finalizer = () => {}, catcher = () => {}, signal = undefined) {
  /**
   * Выполняет GET-запрос с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   * @param {AbortSignal} signal - параметр fetch для управления запросом
   * @returns {Promise} промис запроса
   */
  return finalizeRequest(makeGetRequest(url, {}, signal), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function sendPatchRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет PATCH-запрос с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {Object} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makeParticalUpdateRequest(url, data), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function sendPostRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет POST-запрос с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {Object} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makePostRequest(url, data), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function sendPutRequest (url, data, finalizer = () => {
}, catcher = () => {
}) {
  /**
   * Выполняет PUT-запрос с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {Object} data - данные для отправки
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makeUpdateRequest(url, data), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function sendDeleteRequest (url, finalizer = () => {
}, catcher = () => {
}, p) {
  /**
   * Выполняет DELETE-запрос с обработкой ответа
   * @param {string} url - URL для запроса
   * @param {Function} finalizer - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  finalizeRequest(makeDeleteRequest(url), (data) => finalizer(data, url), (data) => catcher(data, url))
}

export function loadData (url, saver = () => {
}, catcher = () => {
}) {
  /**
   * Псевдоним для функции sendGetRequest
   * @param {string} url - URL для запроса
   * @param {Function} saver - функция, выполняемая при успешном ответе
   * @param {Function} catcher - функция, выполняемая при ошибке
   */
  sendGetRequest(url, saver, catcher)
}

export function setUrlParameters (url, parameters) {
  /**
   * Заменяет параметры в URL
   * @param {string} url - URL с параметрами для замены
   * @param {Object} parameters - объект с параметрами для замены (ключ - что заменяем, значение - на что заменяем)
   * @returns {string} итоговый URL
   */
  for (const key in parameters) {
    url = url.replace('<' + key + '>', parameters[key])
  }
  return url
}

export function addGetParameters (url, parameters) {
  /**
   * Добавляет GET-параметры к URL
   * @param {string} url - базовый URL
   * @param {Object} parameters - объект с параметрами (ключ - имя параметра, значение - значение параметра)
   * @returns {string} URL с добавленными параметрами
   */
  const urlObject = new URL(url)
  for (const el of Object.keys(parameters)) {
    if (parameters[el] === undefined || parameters[el] == null) { urlObject.searchParams.delete(el) } else { urlObject.searchParams.set(el, parameters[el]) }
  }
  return urlObject.toString()
}
